import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  background-color: ${({ selected }) => selected ? '#F7F7F7' : '#FFFFFF'};
  width: 100%;
  margin: 0px 0px 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  padding: 7px 12px;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const DataGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  padding-right: 10px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const FormGrid = styled(DataGrid)`
  align-items: flex-start;
  margin: 6px 0px 3px;
  padding: 5px 0px 0px;
  border-top: 1px solid #F0F0F0;
  grid-template-columns: 5fr repeat(3, 3fr) 4fr;
  cursor: auto;
`

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 4px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin-top: 10px;
`
